import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Box, Flex } from '@chakra-ui/react'

import { removePlusSign } from 'utils/functions/formatNumber'
import Form from 'providers/FormProvider'
import { getCollaboratorInformation } from 'services/api'
import { ICollaboratorInformation, IFetchedCollaboratorInformation } from 'services/IApi.d'
import { useSubscriberContext } from 'providers/SubscriberProvider'
import RegisterUser from './RegisterSuscription/registerUser'
import { defaultUserFields } from './RegisterSuscription/subscriptionTypes'

const AdministratorUser = () => {
  const [searchParams] = useSearchParams()
  const { setAdminCollaboratorData, setFlow } = useSubscriberContext()
  setFlow('administrator')
  const isValidPage: boolean = searchParams.get('estado') === 'VALIDADO'
  const initValues = {
    input: '',
    inputConfirmation: ''
  }

  const getCollaboratorInfo = async (collaboratorId: string): Promise<ICollaboratorInformation> => {
    const response: IFetchedCollaboratorInformation = await getCollaboratorInformation(collaboratorId)
    response.data.telefono =  removePlusSign(response.data.telefono) 
    response.data.codPais =  removePlusSign(response.data.codPais)
    return response.data
  }

  useEffect(() => {
    if (!isValidPage) {
      return
    }
    getCollaboratorInfo(localStorage.getItem('idRepresentante'))
      .then(setAdminCollaboratorData)
  }, [])

  useEffect(() => {
    setFlow('administrator')
  }, [setFlow])

  return (
    <Flex>
      {
        !isValidPage ?
          <Box data-testid='ErrorPage'>Error</Box>
          :
          <Box flex='1' id='right-side' px='6' py='0'>
            <Form initialValues={initValues}>
              <RegisterUser type='user' displayName='usuario' innitialValues={defaultUserFields} />
            </Form>
          </Box>
      }
    </Flex>
  )
}

export default AdministratorUser
